import Vue from 'vue'

export default {
  setZones: (state, zones) => {
    state.zones = zones
  },
  setZone: (state, value) => {
    state.zone = value
  },
  setZoneValue: (state, data) => {
    Vue.set(state.zone, data.key, data.value)
  },
  setIcon: (state, icon) => {
    state.icon = icon
  },
  addZone: (state, value) => {
    const exists = state.zones.some(({ ID }) => ID === value.ID)
    if (!exists) {
      state.zones.push(value)
    }
  },
  updateZone: ({ zones }, value) => {
    if (zones.length) {
      const existing = zones.find(({ ID }) => ID === value.ID)
      Object.assign(existing, value)
    }
  },
  removeZone: ({ zones }, id) => {
    const index = zones.findIndex(({ ID }) => ID === id)
    zones.splice(index, 1)
  }
}
